import intercomLogo from 'images/sources/intercom.svg';
import chromeLogo from 'images/sources/chrome.png';

const info = [
  {
    type: 'connect',
    url: '/v1/intercom_login_url',
    urlName: 'intercom_login_url',
    name: 'Intercom',
    logo: intercomLogo,
    title: 'Intercom',
    visible: true,
  },
  {
    type: 'javascript',
    name: 'javascript',
    logo: chromeLogo,
    title: 'Website',
    visible: true,
    dialog: true,
  },
  {
    url: '/user_identifier',
    name: 'shopify',
    logo: null,
    title: 'Shopify',
    visible: false,
    benefits: [
      'Lorem ipsum dolor sid',
      'Consectetur adipiscing elit',
      'Nam viverra iaculis nulla',
    ],
  }, {
    url: '',
    name: 'salesforce',
    logo: null,
    title: 'Prestashop',
    visible: false,
    benefits: [
      'Lorem ipsum dolor sid',
      'Consectetur adipiscing elit',
      'Nam viverra iaculis nulla',
    ],
  }, {
    url: '',
    name: 'prestashop',
    logo: null,
    title: 'Salesforce',
    visible: false,
    benefits: [
      'Lorem ipsum dolor sid',
      'Consectetur adipiscing elit',
      'Nam viverra iaculis nulla',
    ],
  }];

const title = 'Connect your customer data';
const description = 'Hook up your CRM data so we can work together to find new customers.<br/> We\'ll also help you out with retention.';

export default {
  title,
  description,
  info,
};



// WEBPACK FOOTER //
// ./src/components/core/steps/selectAccount/customerInfo.js